import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2e4146a0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "三方监控引导", -1);
});
var _hoisted_2 = {
  class: "scan-tips"
};
var _hoisted_3 = {
  class: "content-area"
};
var _hoisted_4 = {
  class: "qrcode-section"
};
var _hoisted_5 = {
  class: "scan-area"
};
var _hoisted_6 = {
  class: "qrcode-area"
};
var _hoisted_7 = {
  class: "qrcode-box"
};
var _hoisted_8 = {
  class: "qrcode"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "corner-area"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "lt"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "rt"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "lb"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "rb"
  })], -1);
});
var _hoisted_10 = {
  class: "intro-area"
};
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "tips-title"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "line"
  }), /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "注意事项"), /*#__PURE__*/_createElementVNode("span", {
    class: "line"
  })], -1);
});
var _hoisted_12 = {
  class: "photo-demo"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "photo-tips"
  }, "将手机放置45度斜角位置，覆盖半身", -1);
});
var _hoisted_15 = {
  class: "content-action"
};
var _hoisted_16 = /*#__PURE__*/_createTextVNode(" 已开启三方监控视角 ");
import { TrtcService } from '@/services/exam/trtc.service';
import { useService } from '@kaokei/use-vue-service';
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { DaoService } from '@/services/dao.service';
import { logger } from '@/utils';
import qrcode from 'qrcode';
import GuidePage from '@/assets/image/envCheck/device-guide.png';
import { QrcodeOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _this = this;
    var trtcService = useService(TrtcService);
    var daoService = useService(DaoService);
    var canvasRef = ref();
    var loading = ref(true);
    var clickFlag = ref(false);
    var h5CoverRef = ref(null);
    var coverSize = ref({
      width: 0,
      height: 0
    });
    var coverPos = ref({
      left: 0,
      top: 0
    });
    var isDragging = ref(false);
    var dragStartPointer = ref({
      x: 0,
      y: 0
    });
    var dragStartPos = ref({
      left: 0,
      top: 0
    });
    var movedDuringDrag = ref(false);
    var DRAG_THRESHOLD_PX = 3;
    var EDGE_MARGIN_PX = 8;
    var clamp = function (val, min, max) {
      return Math.min(Math.max(val, min), max);
    };
    var updateCoverSize = function () {
      var el = h5CoverRef.value;
      if (!el) return;
      var rect = el.getBoundingClientRect();
      coverSize.value = {
        width: rect.width,
        height: rect.height
      };
    };
    var clampCoverPosToViewport = function (pos) {
      var maxLeft = Math.max(EDGE_MARGIN_PX, window.innerWidth - coverSize.value.width - EDGE_MARGIN_PX);
      var maxTop = Math.max(EDGE_MARGIN_PX, window.innerHeight - coverSize.value.height - EDGE_MARGIN_PX);
      return {
        left: clamp(pos.left, EDGE_MARGIN_PX, maxLeft),
        top: clamp(pos.top, EDGE_MARGIN_PX, maxTop)
      };
    };
    var initCoverPos = function () {
      updateCoverSize();
      var left = window.innerWidth - 50 - coverSize.value.width;
      var top = window.innerHeight - 50 - coverSize.value.height;
      coverPos.value = clampCoverPosToViewport({
        left: left,
        top: top
      });
    };
    var coverStyle = computed(function () {
      return {
        left: "".concat(coverPos.value.left, "px"),
        top: "".concat(coverPos.value.top, "px"),
        right: 'auto',
        bottom: 'auto',
        touchAction: 'none'
      };
    });
    var onWindowResize = function () {
      updateCoverSize();
      coverPos.value = clampCoverPosToViewport(coverPos.value);
    };
    var onCoverPointerMove = function (ev) {
      if (!isDragging.value) return;
      var dx = ev.clientX - dragStartPointer.value.x;
      var dy = ev.clientY - dragStartPointer.value.y;
      if (!movedDuringDrag.value) {
        if (Math.hypot(dx, dy) >= DRAG_THRESHOLD_PX) {
          movedDuringDrag.value = true;
        }
      }
      coverPos.value = clampCoverPosToViewport({
        left: dragStartPos.value.left + dx,
        top: dragStartPos.value.top + dy
      });
    };
    var endCoverDrag = function (ev) {
      if (!isDragging.value) return;
      isDragging.value = false;
      window.removeEventListener('pointermove', onCoverPointerMove);
      window.removeEventListener('pointerup', endCoverDrag);
      window.removeEventListener('pointercancel', endCoverDrag);
      if (ev && h5CoverRef.value) {
        try {
          h5CoverRef.value.releasePointerCapture(ev.pointerId);
        } catch (_a) {
          // ignore
        }
      }
    };
    var onCoverPointerDown = function (ev) {
      if (ev.pointerType === 'mouse' && ev.button !== 0) return;
      ev.preventDefault();
      updateCoverSize();
      isDragging.value = true;
      movedDuringDrag.value = false;
      dragStartPointer.value = {
        x: ev.clientX,
        y: ev.clientY
      };
      dragStartPos.value = {
        left: coverPos.value.left,
        top: coverPos.value.top
      };
      if (h5CoverRef.value) {
        try {
          h5CoverRef.value.setPointerCapture(ev.pointerId);
        } catch (_a) {
          // ignore
        }
      }
      window.addEventListener('pointermove', onCoverPointerMove);
      window.addEventListener('pointerup', endCoverDrag);
      window.addEventListener('pointercancel', endCoverDrag);
    };
    var onCoverClick = function () {
      if (movedDuringDrag.value) {
        movedDuringDrag.value = false;
        return;
      }
      toggleH5LiveScreen();
    };
    var onContextMenu = function (ev) {
      ev.preventDefault();
      return false;
    };
    var refreshQrcodeFn = function (time) {
      if (time === void 0) {
        time = 0;
      }
      loading.value = true;
      daoService.getTrtcRoomInfo({
        userExamId: trtcService.examService.userExamId,
        contestInfoId: trtcService.examService.contestInfoId,
        platform: 'mobile'
      }).then(function (res) {
        var _a;
        var roomId = res.roomId,
          sdkAppId = res.sdkAppId,
          userSig = res.userSig,
          examStartTime = res.examStartTime;
        var pageUrl = "".concat(location.protocol, "//") + location.host + '/mobile/#/room?' + new URLSearchParams({
          roomId: roomId,
          sdkAppId: sdkAppId.toString(),
          userSig: userSig,
          examStartTime: String(time ? Date.now() + time * 60 * 1000 : examStartTime),
          userId: ((_a = trtcService.examService.userService.user) === null || _a === void 0 ? void 0 : _a.userId) || ''
        }).toString();
        logger.info(pageUrl);
        qrcode.toCanvas(canvasRef.value, pageUrl, {
          errorCorrectionLevel: 'M',
          margin: 0,
          scale: 10,
          width: 280
        }).finally(function () {
          loading.value = false;
        });
      });
    };
    var goNextStep = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, trtcService.getUserIsInRoom()];
            case 1:
              res = _a.sent();
              if (res) {
                trtcService.showH5LiveScreen = false;
              } else {
                _message.error('未检测到三方监控视角，需要您扫码激活三方监控');
              }
              return [2 /*return*/];
          }
        });
      });
    };
    var toggleH5LiveScreen = function () {
      trtcService.showH5LiveScreen = true;
      clickFlag.value = true;
    };
    var handleAfterClose = function () {
      clickFlag.value = false;
    };
    watch(function () {
      return trtcService.showH5LiveScreen;
    }, function (newVal) {
      if (newVal) {
        refreshQrcodeFn();
      }
    });
    watch(function () {
      return trtcService.isShowH5GuideBtn;
    }, function (newVal) {
      if (!newVal) return;
      nextTick(function () {
        initCoverPos();
      });
    }, {
      immediate: true
    });
    onMounted(function () {
      nextTick(function () {
        window.addEventListener('resize', onWindowResize);
      });
    });
    onBeforeUnmount(function () {
      window.removeEventListener('resize', onWindowResize);
      endCoverDrag();
    });
    return function (_ctx, _cache) {
      var _component_a_tooltip = _resolveComponent("a-tooltip");
      var _component_a_spin = _resolveComponent("a-spin");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", null, [_unref(trtcService).isShowH5GuideBtn ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "show-h5-cover",
        ref: function (_value, _refs) {
          _refs['h5CoverRef'] = _value;
          h5CoverRef.value = _value;
        },
        style: _normalizeStyle(_unref(coverStyle)),
        onPointerdown: onCoverPointerDown,
        onClick: onCoverClick
      }, [_createVNode(_component_a_tooltip, {
        placement: "top"
      }, {
        title: _withCtx(function () {
          return [_hoisted_1];
        }),
        default: _withCtx(function () {
          return [_createVNode(_unref(QrcodeOutlined))];
        }),
        _: 1
      })], 36)) : _createCommentVNode("", true), _createVNode(_component_a_modal, {
        visible: _unref(trtcService).showH5LiveScreen,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _unref(trtcService).showH5LiveScreen = $event;
        }),
        title: "三方监控引导",
        centered: "",
        wrapClassName: "need-h5-modal__screen full-modal",
        closable: true,
        footer: null,
        maskClosable: false,
        width: "100%",
        afterClose: handleAfterClose
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "content",
            onContextmenu: onContextMenu
          }, [_createVNode(_component_a_spin, {
            size: "large",
            spinning: loading.value
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_2, " *" + _toDisplayString(clickFlag.value ? '' : '检测到三方监控未开启或断连，') + "请使用微信扫描二维码连接，并提前在手机【设置】中打开常亮模式 ", 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_a_spin, {
                spinning: loading.value,
                wrapperClassName: "check-loading"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_8, [_createElementVNode("canvas", {
                    ref: function (_value, _refs) {
                      _refs['canvasRef'] = _value;
                      canvasRef.value = _value;
                    }
                  }, null, 512)])];
                }),
                _: 1
              }, 8, ["spinning"])]), _hoisted_9])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
                src: _unref(GuidePage),
                alt: ""
              }, null, 8, _hoisted_13)]), _hoisted_14])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_a_button, {
                type: "primary",
                class: "btn",
                onClick: goNextStep
              }, {
                default: _withCtx(function () {
                  return [_hoisted_16];
                }),
                _: 1
              })])])];
            }),
            _: 1
          }, 8, ["spinning"])], 32)];
        }),
        _: 1
      }, 8, ["visible"])]);
    };
  }
});